import { NgModule } from '@angular/core';
import { TestlibComponent } from './testlib.component';

@NgModule({
  declarations: [TestlibComponent],
  imports: [
  ],
  exports: [TestlibComponent]
})
export class TestlibModule { }
